import { Box, Table, TableBody, TableHead, TableRow } from '@mui/material';
import {
  HeadTableCell,
  RowTableCell,
  CustomButton,
  GeneralTableBox,
  PaginationTable,
  DialogBody,
  SearchBar,
  ActionIconButton,
} from '../../../common/components';

import PostAddIcon from '@mui/icons-material/PostAdd';

import PreAdjReasonDialog from '../dialogs/PreAdjReasonDialog';
import { usePaginatedFilter } from '../../../common/hooks/usePaginatedFilter';

const ITEMS_PER_PAGE = 5;

const filterPreAdjReasons = (collection = [], term = '') => {
  if (!term?.trim()) return collection;
  const normalized = term.toLowerCase().trim();
  return collection.filter((reason) => reason.name?.toLowerCase().includes(normalized));
};

const PreAdjReasonsTab = ({
  data,
  selectedItem,
  dialogOpen,
  editMode,
  handleAdd,
  handleEdit,
  handleDelete,
  handleClose,
  handleSave,
}) => {
  const {
    data: paginatedReasons,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
  } = usePaginatedFilter({
    data,
    itemsPerPage: ITEMS_PER_PAGE,
    filterFn: filterPreAdjReasons,
  });

  return (
    <DialogBody sx={{ p: 2, minHeight: '65vh' }}>
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <CustomButton variant="contained" onClick={handleAdd}>
            <PostAddIcon sx={{ mr: 1 }} />
            Agregar
          </CustomButton>
          <SearchBar onSearch={handleSearch} />
        </Box>

        <GeneralTableBox>
          <Table>
            <TableHead>
              <TableRow>
                <HeadTableCell>Motivo</HeadTableCell>
                <HeadTableCell>Descripción</HeadTableCell>
                <HeadTableCell>Acciones</HeadTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedReasons.map((reason, index) => (
                <TableRow key={reason.id || index}>
                  <RowTableCell>{reason.name}</RowTableCell>
                  <RowTableCell>{reason.description}</RowTableCell>
                  <RowTableCell>
                    <ActionIconButton variant="edit" onClick={() => handleEdit(reason)} />
                    <ActionIconButton variant="delete" onClick={() => handleDelete(reason.uuid)} />
                  </RowTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          {totalCount > rowsPerPage && (
            <PaginationTable
              totalPages={totalPages}
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
              totalCount={totalCount}
            />
          )}
        </GeneralTableBox>
      </Box>

      <PreAdjReasonDialog
        open={dialogOpen}
        onClose={handleClose}
        onSave={handleSave}
        selectedItem={selectedItem}
        editMode={editMode}
      />
    </DialogBody>
  );
};

export default PreAdjReasonsTab;
